export const formatMentionedUserName = (firstName: string, lastName?: string) => {
  const lastNameParts = lastName?.split(' ') ?? []
  const lastNameInitials = lastNameParts.map((part) => part.charAt(0)).join('')

  return `${firstName}${lastNameInitials.length > 0 ? ` ${lastNameInitials}` : ''}.`
}
